import { render, staticRenderFns } from "./PortalSidenav.vue?vue&type=template&id=4e00cad8"
import script from "./PortalSidenav.vue?vue&type=script&lang=js"
export * from "./PortalSidenav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports